/**
 * @generated SignedSource<<58e53d8f026966af1693954f020b7fbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentReactionQuery$variables = {
  entityId: string;
  isLoggedIn: boolean;
};
export type contentReactionQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentReactionDisplayQuery">;
};
export type contentReactionQuery = {
  response: contentReactionQuery$data;
  variables: contentReactionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isLoggedIn"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "targetEntityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "contentReactionQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "entityId"
          },
          {
            "kind": "Variable",
            "name": "isLoggedIn",
            "variableName": "isLoggedIn"
          }
        ],
        "kind": "FragmentSpread",
        "name": "contentReactionDisplayQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentReactionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpvoteCount",
        "kind": "LinkedField",
        "name": "upvoteCount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "condition": "isLoggedIn",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "Upvote",
            "kind": "LinkedField",
            "name": "upvote",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "upvoted",
                "storageKey": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "a2b7330b846eef9b7d4d60f11dac9813",
    "id": null,
    "metadata": {},
    "name": "contentReactionQuery",
    "operationKind": "query",
    "text": "query contentReactionQuery(\n  $entityId: String!\n  $isLoggedIn: Boolean!\n) {\n  ...contentReactionDisplayQuery_4h2kMH\n}\n\nfragment contentReactionDisplayQuery_4h2kMH on Query {\n  upvoteCount(filter: {targetEntityId: $entityId}) {\n    count\n    updatedAt\n    id\n  }\n  upvote(filter: {targetEntityId: $entityId}) @include(if: $isLoggedIn) {\n    ...contentReactionDisplayUpvote\n    id\n  }\n}\n\nfragment contentReactionDisplayUpvote on Upvote {\n  upvoted\n  updatedAt\n}\n"
  }
};
})();

(node as any).hash = "0063ebbb1355691b4b8280af00bc60f7";

export default node;
